import { Link } from "react-router-dom";

const footerGroups = [
  {
    title: "内容导航",
    links: [
      { label: "全部剧集", to: "/category/episodes" },
      { label: "演员介绍", to: "/category/actors" },
      { label: "剧情解析", to: "/category/plots" },
      { label: "关于本站", to: "/about" },
    ],
  },
  {
    title: "热门专题",
    links: [
      { label: "婆媳关系全解析", to: "/detail/plot/plot-1" },
      { label: "女性成长线梳理", to: "/detail/plot/plot-5" },
      { label: "结局深度解读", to: "/detail/plot/plot-6" },
      { label: "角色人物志", to: "/detail/actor/actor-1" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-primary-900/40 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-site px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
                <i className="ri-movie-2-line" />
              </span>
              <span className="text-lg font-bold text-background-50">年轻的母亲1</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              本站是围绕电视剧《年轻的母亲1》打造的内容档案站，提供剧集信息、演员资料与剧情深度解析。站点内容以静态演示数据呈现，播放与表单提交均为界面演示，不代表真实播放或后台收集。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 transition-colors hover:text-accent-400">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 transition-colors hover:text-accent-400">
                <i className="ri-wechat-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 transition-colors hover:text-accent-400">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="mb-4 text-sm font-semibold tracking-wide text-background-50">
                <span className="border-b-2 border-accent-500 pb-1">{group.title}</span>
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/80 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-primary-900/60 pt-6 text-xs text-background-300/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 年轻的母亲1 内容档案站 · 本站为非官方粉丝向内容展示站点</p>
          <p>剧集信息与图片均为演示用途，播放功能仅作界面预演</p>
        </div>
      </div>
    </footer>
  );
}